import { fixPagesUrl, isExternalUrl } from '@allesauto/utils/funcs';
import { ISbNode, RichTextSchema } from '@storyblok/react';
import cloneDeep from 'lodash/cloneDeep';

/**
 * Storyblok default field types
 *
 * @see https://www.storyblok.com/docs/terminology/field-type
 */

// Default Link field type
export interface FieldTypeLink {
  id: string;
  url: string;
  rel?: string;
  linktype: string;
  fieldtype: string;
  cached_url?: string;
  target?: '_self' | '_blank' | '_top';
}

export interface ITypeListMarker {
  listItemMarker?: 'bullet' | 'checkmark' | 'dash';
}
export interface ITypeListMarkerColor {
  listItemMarkerColor?: 'purple' | 'green' | 'grey';
}

// Default Asset field type
export interface FieldTypeAsset {
  id: string;
  alt: string;
  name: string;
  focus: string;
  title: string;
  filename: string;
  copyright: string;
  fieldtype: string;
  is_external_url?: boolean;
}

// Default Richtext type
export interface FieldTypeHTML {
  type: string;
  content: any[];
}

/**
 * @deprecated
 */
export interface StoryblokStory {
  content: {
    title: string;
    _uid: string;
    body: any[];
    component: string;
    editable?: string;
    backgroundColor: string;
  };
}

/**
 * Overwriting default RichTextSchema from storyblok to remove root folder from links within a rich text field.
 * @see {@link https://www.storyblok.com/docs/richtext-field }
 * @see {@link https://github.com/storyblok/storyblok-js-client/blob/main/src/schema.ts }
 */

export const customRichTextSchema = cloneDeep(RichTextSchema);

type RichTextLinkSchemaType = {
  tag?: {
    tag: 'a';
    attrs: {
      href?: string;
    };
  }[];
};

customRichTextSchema.marks.link = (node: ISbNode) => {
  if (node?.attrs) {
    const link: RichTextLinkSchemaType = RichTextSchema.marks.link(node);

    if (link.tag) {
      link.tag.forEach((tag) => {
        if (tag.attrs.href) {
          if (!isExternalUrl(tag.attrs.href)) {
            const href = tag.attrs.href.startsWith('/')
              ? tag.attrs.href
              : '/' + tag.attrs.href;
            tag.attrs.href = fixPagesUrl(href);
          }
        }

        return tag;
      });
    }

    return link;
  }

  const defaultFunctionReturn = {
    tag: [
      {
        tag: 'a',
        attrs: {
          href: null,
          uuid: null,
          anchor: null,
          target: null,
          linktype: 'url',
        },
      },
    ],
  };

  return defaultFunctionReturn;
};

export enum StoryblokContentVersion {
  PUBLISHED = 'published',
  DRAFT = 'draft',
}
